import { DataManager } from 'utils/DataManager/dataManager';
import { ISalesForceDataManager } from 'typings/dataManagers';
import { DataState } from 'typings/enums';

class SalesForceDataManager extends DataManager implements ISalesForceDataManager {

    _masterAccountId: string;
    private _labBaseUrl: string;

    setMasterAccountId(masterAccountId: string): void {
        this._masterAccountId = masterAccountId;
    }

    async createTicket(formData: FormData): Promise<TicketSubmissionResult> {
        
        const receive = () => this._postAsForm<FormData>(
            `/api/accounts/${this._masterAccountId}/team/createTicket`,
            formData
        );
        return await this.getData<TicketSubmissionResult>(receive, true) ??
            { success: false, ticketId: 0 } as TicketSubmissionResult;
    }

    async getSuggestedArticles(searchTerms: string): Promise<ArticleSuggestion[]> {

        const path = `${this.labBaseUrl}pendo-salesforce-connector/api/document/?query=${searchTerms ?? '"'}`;

        const receive = () => this._getSalesForceApi<ArticleSuggestionResponse>(path);
        const result = await this.getData<ArticleSuggestionResponse>(receive, false);
        if (result) {
            return result.documents;
        }
        return [];
    }

    async getArticleById(id: string): Promise<ArticleSuggestion[]> {
        const path = `${this.labBaseUrl}pendo-salesforce-connector/api/document/${id ?? '"'}`;
        const receive = () => this._getSalesForceApi<ArticleSuggestion>(path);
        const result = await this.getData<ArticleSuggestion>(receive, false);
        if (result) {
            return [result];
        }
        return [];
    }

    setDataState(state: DataState): void {
        this.protectedTransitionDataState(state);
    }

    setLabBaseUrl(url: string): void {
        this._labBaseUrl = url;
    }

    get labBaseUrl(): string {
        return this._labBaseUrl;
    }
}

export { SalesForceDataManager };
export default SalesForceDataManager;